import { t } from "@/i18n-js/instance";

export interface DateRange {
  label: string;
  value: string;
}

interface UseDateRangesProps {
  onDateRangeSelect?: (range: DateRange) => void;
}

export const useDateRanges = ({
  onDateRangeSelect,
}: UseDateRangesProps = {}) => {
  const dateRanges: DateRange[] = [
    {
      label: t("settings.billing.ai_actions.date_ranges.current"),
      value: "current",
    },
    { label: t("settings.billing.ai_actions.date_ranges.jun"), value: "jun" },
    { label: t("settings.billing.ai_actions.date_ranges.may"), value: "may" },
    { label: t("settings.billing.ai_actions.date_ranges.apr"), value: "apr" },
    { label: t("settings.billing.ai_actions.date_ranges.mar"), value: "mar" },
    { label: t("settings.billing.ai_actions.date_ranges.feb"), value: "feb" },
    { label: t("settings.billing.ai_actions.date_ranges.jan"), value: "jan" },
    { label: t("settings.billing.ai_actions.date_ranges.dec"), value: "dec" },
  ];

  const handleDateRangeSelect = (range: DateRange) => {
    onDateRangeSelect?.(range);
  };

  return {
    dateRanges,
    handleDateRangeSelect,
  };
};
